(function () {
  const handleize = (str) =>
    (str || "")
      .toString()
      .trim()
      .toLowerCase()
      .replace(/['"]/g, "")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");

  function findProductJson(sectionEl) {
    return (
      sectionEl.querySelector('script[type="application/json"][data-cs-product]') ||
      sectionEl.querySelector('script[type="application/json"][data-product-json]') ||
      sectionEl.querySelector('script[type="application/json"][id*="ProductJson"]') ||
      sectionEl.querySelector('script[type="application/json"][id*="product-json"]') ||
      null
    );
  }

  function getProductData(sectionEl) {
    if (sectionEl.__csProduct) return sectionEl.__csProduct;
    const el = findProductJson(sectionEl);
    if (!el) return null;
    try {
      sectionEl.__csProduct = JSON.parse(el.textContent);
      return sectionEl.__csProduct;
    } catch (e) {
      console.warn("CS combo: product json parse failed", e);
      return null;
    }
  }

  function getVariantId(sectionEl) {
    const form = sectionEl.querySelector('form[action*="/cart/add"]');
    const idInput = form?.querySelector('input[name="id"]');
    return idInput?.value ? String(idInput.value) : null;
  }

  function getCurrentVariant(sectionEl) {
    const product = getProductData(sectionEl);
    const vid = getVariantId(sectionEl);
    if (!product || !vid) return null;
    return (product.variants || []).find((v) => String(v.id) === String(vid)) || null;
  }

  function show(node, yes) {
    node.style.display = yes ? "" : "none";
    node.toggleAttribute("hidden", !yes);
  }

  function getPrimaryMediaWrappers(sectionEl) {
    // Dit zijn jouw “bron” media wrappers waar jij data-cs-alt op gezet hebt
    return Array.from(sectionEl.querySelectorAll(".product__media[data-media-id][data-cs-alt]"));
  }

  function applyFilter(sectionEl) {
    const variant = getCurrentVariant(sectionEl);
    if (!variant) return;

    // option1 = Kleur, option2 = Afwerking (zoals jouw UI)
    const kleurValue = variant.option1;
    const afwValue = variant.option2;
    if (!kleurValue || !afwValue) return;

    const kleurTag = `#kleur_${handleize(kleurValue)}`;
    const afwTag = `#afwerking_${handleize(afwValue)}`;

    const wrappers = getPrimaryMediaWrappers(sectionEl);

    // 1) bepaal welke media IDs toegestaan zijn (combo)
    let allowed = new Set();
    wrappers.forEach((w) => {
      const alt = (w.getAttribute("data-cs-alt") || "").toLowerCase();
      if (alt.includes(kleurTag) && alt.includes(afwTag)) {
        allowed.add(String(w.getAttribute("data-media-id")));
      }
    });

    // 2) fallback: alleen kleur
    if (allowed.size === 0) {
      wrappers.forEach((w) => {
        const alt = (w.getAttribute("data-cs-alt") || "").toLowerCase();
        if (alt.includes(kleurTag)) {
          allowed.add(String(w.getAttribute("data-media-id")));
        }
      });
    }

    // 3) toon/verberg ALLES met dezelfde data-media-id (gallery + thumbnails + eventuele clones)
    const allWithId = Array.from(sectionEl.querySelectorAll("[data-media-id]"));
    allWithId.forEach((node) => {
      const id = String(node.getAttribute("data-media-id"));
      show(node, allowed.has(id));
    });

    // 4) als huidige actieve slide verborgen is: klik eerste zichtbare thumbnail (als die bestaat)
    const firstVisibleThumb =
      sectionEl.querySelector('[data-media-id]:not([hidden]) [aria-current="true"]') ||
      sectionEl.querySelector('[data-media-id]:not([hidden]) button, [data-media-id]:not([hidden]) a');

    // (veilig) force refresh
    console.log("CS combo filter:", kleurTag, afwTag, "allowed:", Array.from(allowed));
    window.dispatchEvent(new Event("resize"));
  }

  function init(sectionEl) {
    setTimeout(() => applyFilter(sectionEl), 80);
    sectionEl.addEventListener("change", () => applyFilter(sectionEl));

    const form = sectionEl.querySelector('form[action*="/cart/add"]');
    const idInput = form?.querySelector('input[name="id"]');
    if (idInput) {
      const obs = new MutationObserver(() => applyFilter(sectionEl));
      obs.observe(idInput, { attributes: true, attributeFilter: ["value"] });
    }
  }

  document.addEventListener("DOMContentLoaded", () => {
    console.log("CS combo media filter loaded");
    document.querySelectorAll('[id^="shopify-section-"]').forEach(init);
  });
})();

